import state from './quick-view-state'
import getters from './quick-view-getters'
import actions from './quick-view-actions'
import mutations from './quick-view-mutations'

/**
 * Here, we simply aggregate the definitions laid
 * out in each of the state, getter, action and
 * mutation files within this Vuex module.
 */
export default {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations
}
